export function extractErrorMessage(error, fallback = "Something went wrong") {
  if (!error) return fallback;
  if (typeof error === "string") return error;
  const data = error.response?.data;
  if (data?.message) return data.message;
  if (data?.msg) return data.msg;
  if (typeof data?.error === "string") return data.error;
  if (data?.errors && Array.isArray(data.errors)) {
    return data.errors.map((e) => e.message || e.msg).filter(Boolean).join(", ") || fallback;
  }
  if (error.message) return error.message;
  return fallback;
}
